var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Directive, ElementRef, Renderer } from '@angular/core';
var HeaderTextColorDirective = /** @class */ (function () {
    function HeaderTextColorDirective(el, renderer) {
        this.el = el;
        this.renderer = renderer;
        this.setColor();
    }
    HeaderTextColorDirective.prototype.setColor = function () {
        var text_color = '#000000';
        if (localStorage.getItem('header_data') && localStorage.getItem('header_data') != '') {
            var header_data = JSON.parse(localStorage.getItem('header_data'));
            if (header_data['color']) {
                text_color = header_data['color'];
            }
        }
        this.renderer.setElementStyle(this.el.nativeElement, 'color', text_color);
    };
    HeaderTextColorDirective = __decorate([
        Directive({
            selector: '[header-text-color]'
        }),
        __metadata("design:paramtypes", [ElementRef,
            Renderer])
    ], HeaderTextColorDirective);
    return HeaderTextColorDirective;
}());
export { HeaderTextColorDirective };
//# sourceMappingURL=header-text-color.js.map


// WEBPACK FOOTER //
// ./src/directives/header-text-color/header-text-color.ts.pre-build-optimizer.js